import { FastArrowRight } from "iconoir-react";

import { createIcon } from "../create-icon";

export const IconFastArrowRight12Line = createIcon(FastArrowRight, 12, "Line");
export const IconFastArrowRight16Line = createIcon(FastArrowRight, 16, "Line");
export const IconFastArrowRight20Line = createIcon(FastArrowRight, 20, "Line");
export const IconFastArrowRight24Line = createIcon(FastArrowRight, 24, "Line");
export const IconFastArrowRight32Line = createIcon(FastArrowRight, 32, "Line");
export const IconFastArrowRight48Line = createIcon(FastArrowRight, 48, "Line");
export const IconFastArrowRight64Line = createIcon(FastArrowRight, 64, "Line");
